import React from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const numericMask = (prefix: string) =>
  createNumberMask({
    prefix: prefix || '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
    integerLimit: 13,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: false
  });

const formatarCep = (cep: string): string =>
  cep.replace(/\D/g, '').replace(/^(\d{5})(\d{3})$/, '$1-$2');

const handleCnpjUpperCaseKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>
): void => {
  if (
    e.key.length === 1 &&
    /[a-z]/.test(e.key) &&
    !e.ctrlKey &&
    !e.metaKey &&
    !e.altKey
  ) {
    e.preventDefault();
    document.execCommand('insertText', false, e.key.toUpperCase());
  }
};

export { numericMask, formatarCep, handleCnpjUpperCaseKeyDown };
